import { defineStore } from 'pinia';

import {
  AutocompleteRepository,
  GiftAutocompleteResponse,
} from '@/repositories/generated';

type GiftAutocompleteRequestForm = {
  term: string | undefined;
};

type GiftAutocompleteStoreState = {
  searchCache: Record<string, GiftAutocompleteResponse>;
};

/**
 * 検索候補表示コンポーネント用にレスポンスをキャッシュするストア
 */
export const useGiftAutocompleteStore = defineStore('giftAutocomplete', {
  state: (): GiftAutocompleteStoreState => ({
    searchCache: {},
  }),
  getters: {
    // idを元にキャッシュから取得するcomputed。なければ自動補完APIを非同期で叩く
    getByIdOrDummy: (state) => (id: string): GiftAutocompleteResponse => {
      const cache = state.searchCache[id];
      if (cache) {
        return cache;
      }

      // 自動補完APIが１度だけ叩かれるように、キャッシュにダミーデータを差し込んでおく
      const dummyItem = { id, name: '' } as GiftAutocompleteResponse;
      state.searchCache[id] = dummyItem;
      (async () => {
        const res = await AutocompleteRepository.searchGift({ term: id });
        res.forEach((it) => {
          state.searchCache[it.id] = it;
        });
      })();
      return dummyItem;
    },
  },
  actions: {
    async search(form: GiftAutocompleteRequestForm): Promise<GiftAutocompleteResponse[]> {
      const res = await AutocompleteRepository.searchGift(form);
      res.forEach((it) => {
        this.searchCache[it.id] = it;
      });
      return res;
    },
  },
});
